import React, { useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_API_URL || '/api';
async function req(path) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API}${path}`, { headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) } });
  return res.json();
}
async function patchReq(path, body) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API}${path}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }, body: JSON.stringify(body) });
  return res.json();
}

const SL = {
  pendente: { label: 'Pendente', color: '#c9a227', bg: 'rgba(201,162,39,0.15)' },
  confirmado: { label: 'Confirmado', color: '#6ee7b7', bg: 'rgba(37,211,102,0.15)' },
  enviado: { label: 'Enviado', color: '#4a9af5', bg: 'rgba(74,154,245,0.15)' },
  entregue: { label: 'Entregue', color: '#34d399', bg: 'rgba(37,211,102,0.2)' },
  cancelado: { label: 'Cancelado', color: '#fca5a5', bg: 'rgba(239,68,68,0.15)' },
};
const STATUSES = ['pendente', 'confirmado', 'enviado', 'entregue', 'cancelado'];

export default function StorePedidos() {
  const [orders, setOrders] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('');
  const [search, setSearch] = useState('');
  const [sel, setSel] = useState(null);
  const [saving, setSaving] = useState(false);

  const fetchOrders = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filterStatus) params.set('status', filterStatus);
      if (search) params.set('search', search);
      const data = await req('/admin/store/orders?' + params);
      setOrders(data.orders || []);
      setTotal(data.total || 0);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [filterStatus, search]);

  useEffect(() => { fetchOrders(); }, [fetchOrders]);

  const openDetail = async (id) => {
    try { const data = await req('/admin/store/orders/' + id); setSel(data); } catch (e) { console.error(e); }
  };

  const updateStatus = async (id, status, tracking_code) => {
    setSaving(true);
    try {
      await patchReq('/admin/store/orders/' + id + '/status', { status, tracking_code });
      fetchOrders();
      if (sel && sel.id === id) setSel(prev => ({ ...prev, status, tracking_code }));
    } catch (e) { console.error(e); }
    setSaving(false);
  };

  if (sel) {
    const s = SL[sel.status] || {};
    return (
      <div style={{ padding: '1.5rem', maxWidth: 700 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
          <button onClick={() => setSel(null)} style={B.back}>← Voltar</button>
          <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: 'var(--text-hi)' }}>{sel.order_number}</h2>
          <span style={{ padding: '3px 10px', borderRadius: 10, fontSize: '0.68rem', fontWeight: 700, background: s.bg, color: s.color }}>{s.label}</span>
        </div>

        <Sec title="Cliente">
          <Info l="Nome" v={sel.customer_name} />
          <Info l="Email" v={sel.customer_email} />
          <Info l="Telefone" v={sel.customer_phone || '—'} />
          <Info l="Data" v={new Date(sel.created_at).toLocaleString('pt-BR')} />
        </Sec>

        <Sec title="Itens do Pedido">
          <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr style={{ background: 'var(--surface)' }}>
                {['Produto', 'Qtd', 'Unit.', 'Total'].map(h => <th key={h} style={{ padding: '8px 12px', textAlign: 'left', fontSize: '0.72rem', fontWeight: 600, color: 'var(--text-mid)', textTransform: 'uppercase' }}>{h}</th>)}
              </tr></thead>
              <tbody>{sel.items?.map((it, i) => (
                <tr key={i} style={{ borderTop: '1px solid var(--border)' }}>
                  <td style={{ padding: '8px 12px', fontSize: '0.82rem', color: 'var(--text-hi)' }}>{it.product_name}{it.variant_name && <span style={{ color: 'var(--text-lo)', fontSize: '0.75rem' }}> ({it.variant_name})</span>}</td>
                  <td style={{ padding: '8px 12px', fontSize: '0.82rem', color: 'var(--text-mid)' }}>{it.quantity}</td>
                  <td style={{ padding: '8px 12px', fontSize: '0.82rem', color: 'var(--text-mid)' }}>R$ {parseFloat(it.unit_price).toFixed(2)}</td>
                  <td style={{ padding: '8px 12px', fontSize: '0.82rem', fontWeight: 600, color: 'var(--text-hi)' }}>R$ {parseFloat(it.total).toFixed(2)}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 16, marginTop: 10, fontSize: '0.85rem' }}>
            <span style={{ color: 'var(--text-mid)' }}>Subtotal: R$ {parseFloat(sel.subtotal).toFixed(2)}</span>
            <span style={{ fontWeight: 700, color: 'var(--accent)', fontSize: '1rem' }}>Total: R$ {parseFloat(sel.total).toFixed(2)}</span>
          </div>
        </Sec>

        <Sec title="Entrega">
          <Info l="Tipo" v={sel.shipping_type === 'retirada_jf' ? 'Retirada em JF' : sel.shipping_type === 'entrega_jf' ? 'Entrega em JF' : 'Correios'} />
          {sel.shipping_street && <Info l="Endereço" v={`${sel.shipping_street}, ${sel.shipping_number || ''} - ${sel.shipping_neighborhood || ''}, ${sel.shipping_city || ''}-${sel.shipping_state || ''}`} />}
          <Info l="Pagamento" v={sel.payment_method === 'pix' ? 'Pix' : sel.payment_method === 'cartao_credito' ? 'Cartão Crédito' : sel.payment_method || '—'} />
          {sel.notes && <Info l="Obs" v={sel.notes} />}
        </Sec>

        <Sec title="Atualizar Status">
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
            {STATUSES.map(st => {
              const sl = SL[st]; const isA = sel.status === st;
              return <button key={st} onClick={() => updateStatus(sel.id, st, sel.tracking_code)} disabled={saving}
                style={{ padding: '6px 16px', borderRadius: 8, fontSize: '0.75rem', fontWeight: 700, cursor: 'pointer',
                  background: isA ? sl.bg : 'var(--surface)', color: isA ? sl.color : 'var(--text-lo)',
                  border: isA ? '2px solid ' + sl.color : '1px solid var(--border)', opacity: saving ? 0.5 : 1 }}>{sl.label}</button>;
            })}
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input placeholder="Código de rastreio" value={sel.tracking_code || ''} onChange={e => setSel(p => ({ ...p, tracking_code: e.target.value }))}
              style={{ flex: 1, padding: '8px 12px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text-hi)', fontSize: '0.85rem' }} />
            <button onClick={() => updateStatus(sel.id, sel.status, sel.tracking_code)} disabled={saving}
              style={{ padding: '8px 18px', background: 'var(--accent)', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 700, fontSize: '0.78rem', cursor: 'pointer' }}>Salvar</button>
          </div>
        </Sec>

        <a href={`https://wa.me/55${(sel.customer_phone || '').replace(/\D/g, '')}?text=${encodeURIComponent('Olá ' + sel.customer_name + '! Seu pedido ' + sel.order_number + ' foi atualizado: ' + (SL[sel.status]?.label || sel.status) + (sel.tracking_code ? '. Rastreio: ' + sel.tracking_code : ''))}`}
          target="_blank" rel="noopener noreferrer"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '10px 20px', background: '#25d366', color: '#fff', borderRadius: 8, fontWeight: 700, fontSize: '0.82rem', textDecoration: 'none', marginTop: 16 }}>
          📲 Enviar via WhatsApp
        </a>
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem' }}>
      <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: 'var(--text-hi)', marginBottom: 20 }}>Pedidos da Loja <span style={{ color: 'var(--accent-2)', fontWeight: 400, fontSize: '0.9rem' }}>({total})</span></h2>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <input type="text" placeholder="Buscar por número ou cliente..." value={search} onChange={e => setSearch(e.target.value)}
          style={{ flex: 1, maxWidth: 300, padding: '8px 12px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text-hi)', fontSize: '0.85rem' }} />
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}
          style={{ padding: '8px 12px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--text-mid)', fontSize: '0.82rem' }}>
          <option value="">Todos</option>
          {STATUSES.map(st => <option key={st} value={st}>{SL[st].label}</option>)}
        </select>
      </div>
      {loading ? <p style={{ color: 'var(--text-lo)' }}>Carregando...</p> :
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {orders.map(o => {
            const s = SL[o.status] || {};
            return <div key={o.id} onClick={() => openDetail(o.id)}
              style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 16px', cursor: 'pointer' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                <span style={{ fontWeight: 700, color: 'var(--accent)', fontSize: '0.9rem' }}>{o.order_number}</span>
                <span style={{ padding: '3px 10px', borderRadius: 10, fontSize: '0.65rem', fontWeight: 700, background: s.bg, color: s.color }}>{s.label}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', color: 'var(--text-mid)' }}>
                <span>{o.customer_name}</span><span>{new Date(o.created_at).toLocaleDateString('pt-BR')}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4, fontSize: '0.8rem' }}>
                <span style={{ color: 'var(--text-lo)' }}>{o.item_count} {o.item_count === 1 ? 'item' : 'itens'}</span>
                <span style={{ fontWeight: 700, color: 'var(--text-hi)' }}>R$ {parseFloat(o.total).toFixed(2)}</span>
              </div>
            </div>;
          })}
          {orders.length === 0 && <p style={{ color: 'var(--text-lo)', textAlign: 'center', padding: '2rem' }}>Nenhum pedido encontrado</p>}
        </div>
      }
    </div>
  );
}

function Sec({ title, children }) {
  return <div style={{ marginBottom: 20 }}><h3 style={{ fontSize: '0.78rem', fontWeight: 700, color: 'var(--text-mid)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8, paddingBottom: 6, borderBottom: '1px solid var(--border)' }}>{title}</h3>{children}</div>;
}
function Info({ l, v }) {
  return <div style={{ display: 'flex', gap: 10, marginBottom: 4, fontSize: '0.82rem' }}><span style={{ color: 'var(--text-lo)', minWidth: 90 }}>{l}:</span><span style={{ color: 'var(--text-hi)' }}>{v}</span></div>;
}
const B = { back: { padding: '6px 14px', background: 'transparent', color: 'var(--text-mid)', border: '1px solid var(--border)', borderRadius: 6, fontSize: '0.78rem', cursor: 'pointer' } };
